import React from "react";
import { Strings,ChangeLanguage} from "INTL/i18n";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import changeLanguage from "MODULES/App/actions/ChangeLanguage";
import PaymentRedirect from "./PaymentRedirect";
import "./Payer.less";
import PaymentResult from "./PaymentResult";
import { PayerParam } from "./PayerConstants";
import PaymentBase from "./PaymentBase";
import "./Payer.css";
import {PageView, initGA} from "MODULES/Tracking";
import { GOOGLE_ANALYTICS } from "CONSTANTS/AppConstants";

class PaymentFailed extends PaymentBase {
  constructor(props) {
    super(props);
    this.state = {
      redirectUrl: "",
    };
  }
  componentDidMount() {
    initGA(GOOGLE_ANALYTICS.TRACKING_ID);
    PageView();
    let searchQueryString = window.location.hash.split("?")[1];
    let redirectQueryString = "?" + window.location.hash.split("?")[2];
    let urlParams = new URLSearchParams(searchQueryString);
    let languageCode = urlParams.get(PayerParam.lang);
    ChangeLanguage(languageCode);
    this.props.changeLanguageInState(languageCode);
    let redirectUrl;
    if (urlParams.get(PayerParam.redirect)) {
      redirectUrl = urlParams.get(PayerParam.redirect) + redirectQueryString;
    }
    this.setState({
      redirectUrl: redirectUrl,
    });
  }

  render() {
    return (
      <div>
        {this.renderHeader(this.props.selectedLanguage)}
        <div className="App_body">
          <div className="payerContainer">
            <div className={this.props.selectedLanguage === "ar"?"Rectangle_dialog_fail_rtl":"Rectangle_dialog_fail"}>
              <div className={this.props.selectedLanguage === "ar"?"Payment_Fail_Label_rtl":"Payment_Fail_Label"}>
                {Strings("payment_fail_lbl")}
              </div>
              <div className={this.props.selectedLanguage === "ar"?"Thank_You_Desc_RTL":"Thank_You_Desc"}>
                {Strings("payment_fail_desc")}
              </div>
              {this.state.redirectUrl && (
                <PaymentRedirect redirectUrl={this.state.redirectUrl} />
              )}
              <PaymentResult />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedLanguage: state.LanguageReducer.selectedLanguage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      changeLanguageInState: changeLanguage,
    },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentFailed);



// WEBPACK FOOTER //
// ./src/modules/Payer/PaymentFailed.js